

export function hexToRgbComponents(hex: string): [number, number, number] {
  const hexNumber = parseInt(hex.slice(1), 16);
  const red = (hexNumber >> 16) & 255;
  const green = (hexNumber >> 8) & 255;
  const blue = hexNumber & 255;

  return [red, green, blue];
}

/**
 * 
 * @param from first color (hex)
 * @param to second color (hex)
 * @param weight a number between 0 and 1
 */
export function interpolateBetweenColors(from: string, to: string, weight: number): [number, number, number] {
  const first = hexToRgbComponents(from);
  const second = hexToRgbComponents(to);

  const newRGBComponent = (firstRGBComponent: number, secondRGBComponent: number) => (secondRGBComponent - firstRGBComponent) * weight + firstRGBComponent;
  const newRed = Math.round(newRGBComponent(first[0], second[0]));
  const newGreen = Math.round(newRGBComponent(first[1], second[1]));
  const newBlue = Math.round(newRGBComponent(first[2], second[2]));
  return [newRed, newGreen, newBlue];
}

export function isDarkColor(rgb: [number, number, number] | string) {
  if (typeof rgb === 'string')
    rgb = hexToRgbComponents(rgb);
  
  const [red, green, blue] = rgb;
  // Hard coded based on: https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
  return (red * 0.299 + green * 0.587 + blue * 0.114) <= 186; 
}

export function rgbComponentsToHex(rgbComponents: [number, number, number]) {
  const [red, green, blue] = rgbComponents;
  return `#${((1 << 24) + (red << 16) + (green << 8) + blue).toString(16).slice(1)}`;
}